import { render, staticRenderFns } from "./FnFormatPhone.vue?vue&type=template&id=5459ba64&"
import script from "./FnFormatPhone.vue?vue&type=script&lang=js&"
export * from "./FnFormatPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5459ba64')) {
      api.createRecord('5459ba64', component.options)
    } else {
      api.reload('5459ba64', component.options)
    }
    module.hot.accept("./FnFormatPhone.vue?vue&type=template&id=5459ba64&", function () {
      api.rerender('5459ba64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-format/components/FnFormatPhone.vue"
export default component.exports